import * as React from "react";
import { css } from "@emotion/core";

import InspectorHeader from "./InspectorHeader";
import AnnotationInspector from "./AnnotationInspector";
import AnnotationLayerInspector from "./AnnotationLayerInspector";
import AssetInspector from "./AssetInspector";
import AdHocInspector from "./AdHocInspector";
import CannotInspector from "./CannotInspector";

import {
  useSinkActions,
  useAnnotationState,
  useAnnotationActions,
} from "context/";
import { useCallback } from "react";
import { Card } from "@blueprintjs/core";

const RightPane = ({ model }) => {
  const { stopInspecting } = useSinkActions();
  const { deselect } = useAnnotationActions();

  const closeInspector = useCallback(() => {
    stopInspecting();
    deselect();
  }, [stopInspecting, deselect]);

  React.useEffect(() => {
    return () => {
      closeInspector();
    };
  }, [closeInspector]);

  if (!model) return null;

  return (
    <aside
      css={css`
        width: 372px;
        background: var(--background-gradient);
        height: 100%;
      `}
    >
      <Inspector model={model} closeInspector={closeInspector} />
    </aside>
  );
};

const Inspector = ({ model, ...props }) => {
  if (model.class.name === "Annotation") {
    return <AnnotationInspector key={model.id} annotation={model} {...props} />;
  }

  if (model.class.name === "Asset") {
    return <AssetInspector asset={model} {...props} />;
  }

  if (model.class.name === "Layer") {
    return <AnnotationLayerInspector layer={model} {...props} />;
  }

  if (model.class.name === "AdHoc") {
    return <AdHocInspector model={model} {...props} />;
  }

  if (model.class.name === "Cannot") {
    return <CannotInspector problem={model.problem} {...props} />;
  }

  console.error(
    `RightPane received model that it did not know how to handle: ${model}`
  );

  return null;
};

export default RightPane;
